import { React } from "react";
import PropTypes from "prop-types";

function CourseLandingPageDescription({ courseDescription }) {

  return (
    <div className="CourseLandingPage-description container-content">
      <div className="container-description">
        <h2>
          What <em><span className="lowercase">will</span> I</em><br/>Learn?
        </h2>
        <p>{courseDescription}</p>
      </div>
    </div>
  )
}

CourseLandingPageDescription.propTypes = {
  courseDescription: PropTypes.string
};

export default CourseLandingPageDescription;